import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { FormattedMessage, useTranslator } from '@jutro/locale';

import metadata from './MLAddressChangeNewStatePopup.metadata.json5';
import messages from './MLAddressChangeNewStatePopup.messages';
import styles from './MLAddressChangeNewStatePopup.module.scss';

const MLAddressChangeNewStatePopup = (props) => {
    const {
        isAmp,
        MLQBPath,
        startNewQuote,
        restorePolicyAddress,
        onCancel
    } = props;

    const translator = useTranslator();   

    const newProperty = useCallback(() => {
        onCancel();
        startNewQuote();
    }, [onCancel, startNewQuote]);

    const cancelStateChange = useCallback(() => {
        onCancel();
        restorePolicyAddress();
    }, [onCancel, restorePolicyAddress]);

    const overrides = {
        movingToNewStateNonAMPMsg: {
            visible: !isAmp,
            content: <FormattedMessage
                {...messages.movingToNewState}
                values={{
                    strongSpan: <strong>{translator(messages.startNewQuote)}</strong>
                }}
            />
        },
        movingToNewStateAMPMsg: {
            visible: isAmp,
            content: <FormattedMessage
                {...messages.youAreMovingToNewState}
                values={{
                    strongSpan: <strong>{translator(messages.startNewQuote)}</strong>
                }}
            />
        },
        stateStartNewQuoteBtn: {
            visible: !isAmp,
            onClick: newProperty
        },
        stateStartNewQuoteLink: {
            visible: isAmp,
            href: MLQBPath
        },
        stateCancelBtn: {
            onClick: cancelStateChange
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
};

MLAddressChangeNewStatePopup.propTypes = {
    isAmp: PropTypes.bool.isRequired,
    MLQBPath: PropTypes.string.isRequired,
    startNewQuote: PropTypes.func.isRequired,
    restorePolicyAddress: PropTypes.func.isRequired,
    onCancel: PropTypes.func
};

export default MLAddressChangeNewStatePopup;
